"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Button = _interopRequireDefault(require("../Button")),
    _Icon = _interopRequireDefault(require("../Icon")),
    _LabelWrapper = _interopRequireDefault(require("../../common/components/LabelWrapper"));

require("./styles/_number-changer.scss");

function getNumberIcon(a) {
  return _react["default"].createElement(_Icon["default"], {
    name: a,
    size: 15,
    color: "white"
  });
}

function onClick(a, b) {
  var c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : {},
      d = c.increment;
  return function () {
    var c = d ? 1 : -1;
    a(b + c);
  };
}

function NumberChanger(a) {
  var b = a.value,
      c = void 0 === b ? 0 : b,
      d = a.onChangeNumber,
      e = a.disabled,
      f = a.label,
      g = a.suffixLabel,
      h = void 0 === g ? "" : g,
      i = a.max,
      j = a.hideValue,
      k = e || "number" == typeof i && c >= i;
  return _react["default"].createElement(_LabelWrapper["default"], {
    className: "number-changer__label-wrapper",
    label: f
  }, _react["default"].createElement("div", {
    className: "number-changer"
  }, _react["default"].createElement(_Button["default"], {
    className: (0, _classnames["default"])("number-changer-minus", {
      "number-changer-minus--btn-disabled": 0 === c || e
    }),
    disabled: 0 === c || e,
    onClick: onClick(d, c)
  }, getNumberIcon("remove")), _react["default"].createElement("div", {
    className: "number-changer__value"
  }, _react["default"].createElement("strong", null, "".concat(j ? "" : "".concat(c, " ")).concat(h))), _react["default"].createElement(_Button["default"], {
    className: (0, _classnames["default"])("number-changer-add", {
      "number-changer-add--btn-disabled": k
    }),
    onClick: k ? void 0 : onClick(d, c, {
      increment: !0
    }),
    disabled: k
  }, getNumberIcon("addfat"))));
}

var _default = (0, _react.memo)(NumberChanger);

exports["default"] = _default;